// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1jXNA","productName":"Table_productName__2KFNC"};